import React from 'react';

import PropTypes from 'prop-types';
import { IconButton, Close } from '@tds/core-interactive-icon';

import request from '../../utils/request';
import {
  Backdrop,
  ModalMain,
  ModalInner,
  ModalMessageMain,
  ModalCancel,
  ModalHeading
} from './css';
import {
  SummaryGroupWrapper,
  SummaryCategory,
  SummaryDetail
} from '../../form/css';
import { profileKeysToList } from '../../utils/constant';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const AccountInfo = ({ onClose }) => {
  const localizedStrings = useLocalizedStringsContext();
  const { profileKeys } = localizedStrings;
  const profile = request.getProfile();

  return (
    <Backdrop>
      <ModalMain>
        <ModalInner>
          <ModalMessageMain>
            <ModalHeading>My Account Info</ModalHeading>
            {profile &&
              profileKeysToList.map(key => {
                if (profile[key])
                  return (
                    <SummaryGroupWrapper key={`rep-info-${key}`}>
                      <SummaryCategory>
                        <span className="frg-body-font-14px">
                          {profileKeys[key]}
                        </span>
                      </SummaryCategory>
                      <SummaryDetail>
                        <span className="frg-body-font-14px">
                          {key === 'role_id'
                            ? profile.role.description
                            : profile[key]}
                        </span>
                      </SummaryDetail>
                      <div className="clear" />
                    </SummaryGroupWrapper>
                  );
                return null;
              })}
          </ModalMessageMain>
          <ModalCancel>
            <IconButton icon={Close} onClick={onClose} a11yText="Close" />
          </ModalCancel>
        </ModalInner>
      </ModalMain>
    </Backdrop>
  );
};

AccountInfo.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default AccountInfo;
